import Axios from './axios_wrapper'

export function exportPatients () {
  return Axios({
    url: '/csv/patients',
    method: 'GET'
  })
}

export function exportUsers (role) {
  return Axios({
    url: `/admin/csv/users?role=${role}`,
    method: 'GET'
  })
}

export function exportReports ({ report_id, surgeon_id, report_name, filters }) {
  return Axios({
    url: `/csv/reports/${report_id}?surgeon_id=${surgeon_id}&report_name=${report_name}${filters}`,
    method: 'GET'
  })
}

export function exportReportsAdmin ({ report_id, report_name, filters }) {
  return Axios({
    url: `/admin/csv/reports/${report_id}?report_name=${report_name}${filters}`,
    method: 'GET'
  })
}

export function exportReportsDistributor ({ report_id, report_name, filters }) {
  return Axios({
    url: `/distributor/csv/reports/${report_id}?report_name=${report_name}${filters}`,
    method: 'GET',
    data: report_name
  })
}

export function exportReportsHospitalAdmin ({ report_id, report_name, filters }) {
  return Axios({
    url: `/hospital_admin/csv/reports/${report_id}?report_name=${report_name}${filters}`,
    method: 'GET',
    data: report_name
  })
}

export function exportUsersDistributor (role) {
  return Axios({
    url: `/distributor/csv/users?role=${role}`,
    method: 'GET'
  })
}

export function exportUsersHospitalAdmin (role) {
  return Axios({
    url: `/hospital_admin/csv/users?role=${role}`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/csvs.js
// module id = null
// module chunks = 